import type { DashboardSummary } from './schema';

export function getSeedDashboard(
  tab = 'eats',
  period = 'week',
  date = '23 июня 2026',
): DashboardSummary {
  const periodLabel =
    period === 'month'
      ? 'В этом месяце'
      : period === 'year'
        ? 'За год'
        : 'На этой неделе';

  if (tab === 'cargo') {
    return {
      dateText: date,
      tab: 'cargo',
      kpis: {
        totalOrders: { label: 'Общее кол-во заказов', value: '18 шт', raw: 18 },
        totalRevenue: {
          label: 'Общая сумма заказов',
          value: '450 тыс. сум',
          raw: 450000,
        },
        newClients: { label: 'Новые клиенты', value: '6 шт', raw: 6 },
        newCouriers: { label: 'Новые курьеры', value: '2 шт', raw: 2 },
        averageCheck: { label: 'Средний чек', value: '25 000 сум', raw: 25000 },
        averageDistance: {
          label: 'Ср. расстояние',
          value: '8 км/ 350 км',
          avgKm: 8,
          maxKm: 350,
        },
      },
      sales: {
        title: 'Все перевозки Cargo',
        total: '18 шт',
        periodLabel,
        points: [
          { date: '2026-10-24', label: 'Окт 24', value: 15000 },
          { date: '2026-10-25', label: 'Окт 25', value: 20000 },
          { date: '2026-10-26', label: 'Окт 26', value: 18000 },
          { date: '2026-10-27', label: 'Окт 27', value: 25000 },
          { date: '2026-10-28', label: 'Окт 28', value: 30000 },
          { date: '2026-10-29', label: 'Окт 29', value: 22000 },
          { date: '2026-10-30', label: 'Окт 30', value: 28000 },
          { date: '2026-10-31', label: 'Окт 31', value: 35000 },
        ],
        yTicks: [50000, 40000, 30000, 20000, 10000],
      },
      courierTracking: {
        title: 'Отслеживание курьеров',
        totalCouriers: 45,
        segments: [
          {
            id: 'with_order',
            label: 'С заказом',
            percentage: 50,
            count: 22,
            color: '#2EAD5F',
          },
          {
            id: 'two_orders',
            label: 'Два заказа',
            percentage: 20,
            count: 9,
            color: '#3B82F6',
          },
          {
            id: 'no_order',
            label: 'Без заказа',
            percentage: 20,
            count: 9,
            color: '#F59E0B',
          },
          {
            id: 'resting',
            label: 'Отдыхают',
            percentage: 10,
            count: 5,
            color: '#8B0A8B',
          },
        ],
      },
    };
  }

  if (tab === 'drive') {
    return {
      dateText: date,
      tab: 'drive',
      kpis: {
        totalOrders: { label: 'Общее кол-во заказов', value: '42 шт', raw: 42 },
        totalRevenue: {
          label: 'Общая сумма заказов',
          value: '850 тыс. сум',
          raw: 850000,
        },
        newClients: { label: 'Новые клиенты', value: '19 шт', raw: 19 },
        newCouriers: { label: 'Новые курьеры', value: '8 шт', raw: 8 },
        averageCheck: { label: 'Средний чек', value: '20 200 сум', raw: 20200 },
        averageDistance: {
          label: 'Ср. расстояние',
          value: '12 км/ 420 км',
          avgKm: 12,
          maxKm: 420,
        },
      },
      sales: {
        title: 'Все поездки Noor Drive',
        total: '42 шт',
        periodLabel,
        points: [
          { date: '2026-10-24', label: 'Окт 24', value: 28000 },
          { date: '2026-10-25', label: 'Окт 25', value: 34000 },
          { date: '2026-10-26', label: 'Окт 26', value: 30000 },
          { date: '2026-10-27', label: 'Окт 27', value: 42000 },
          { date: '2026-10-28', label: 'Окт 28', value: 39000 },
          { date: '2026-10-29', label: 'Окт 29', value: 35000 },
          { date: '2026-10-30', label: 'Окт 30', value: 44000 },
          { date: '2026-10-31', label: 'Окт 31', value: 48000 },
        ],
        yTicks: [50000, 40000, 30000, 20000, 10000],
      },
      courierTracking: {
        title: 'Отслеживание водителей',
        totalCouriers: 65,
        segments: [
          {
            id: 'with_order',
            label: 'С заказом',
            percentage: 62,
            count: 40,
            color: '#2EAD5F',
          },
          {
            id: 'two_orders',
            label: 'Два заказа',
            percentage: 18,
            count: 12,
            color: '#3B82F6',
          },
          {
            id: 'no_order',
            label: 'Без заказа',
            percentage: 12,
            count: 8,
            color: '#F59E0B',
          },
          { id: 'resting', label: 'Отдыхают', percentage: 8, count: 5, color: '#8B0A8B' },
        ],
      },
    };
  }

  if (tab === 'all') {
    return {
      dateText: date,
      tab: 'all',
      kpis: {
        totalOrders: { label: 'Общее кол-во заказов', value: '98 шт', raw: 98 },
        totalRevenue: {
          label: 'Общая сумма заказов',
          value: '2,320 млн. сум',
          raw: 2320000000,
        },
        newClients: { label: 'Новые клиенты', value: '40 шт', raw: 40 },
        newCouriers: { label: 'Новые курьеры', value: '15 шт', raw: 15 },
        averageCheck: { label: 'Средний чек', value: '23 600 сум', raw: 23600 },
        averageDistance: {
          label: 'Ср. расстояние',
          value: '6 км/ 280 км',
          avgKm: 6,
          maxKm: 280,
        },
      },
      sales: {
        title: 'Все продажи платформы',
        total: '98 шт',
        periodLabel,
        points: [
          { date: '2026-10-24', label: 'Окт 24', value: 38000 },
          { date: '2026-10-25', label: 'Окт 25', value: 42000 },
          { date: '2026-10-26', label: 'Окт 26', value: 39000 },
          { date: '2026-10-27', label: 'Окт 27', value: 49000 },
          { date: '2026-10-28', label: 'Окт 28', value: 41000 },
          { date: '2026-10-29', label: 'Окт 29', value: 46000 },
          { date: '2026-10-30', label: 'Окт 30', value: 48000 },
          { date: '2026-10-31', label: 'Окт 31', value: 50000 },
        ],
        yTicks: [50000, 40000, 30000, 20000, 10000],
      },
      courierTracking: {
        title: 'Отслеживание курьеров',
        totalCouriers: 210,
        segments: [
          {
            id: 'with_order',
            label: 'С заказом',
            percentage: 55,
            count: 115,
            color: '#2EAD5F',
          },
          {
            id: 'two_orders',
            label: 'Два заказа',
            percentage: 25,
            count: 52,
            color: '#3B82F6',
          },
          {
            id: 'no_order',
            label: 'Без заказа',
            percentage: 14,
            count: 30,
            color: '#F59E0B',
          },
          {
            id: 'resting',
            label: 'Отдыхают',
            percentage: 6,
            count: 13,
            color: '#8B0A8B',
          },
        ],
      },
    };
  }

  if (tab === 'top_couriers') {
    return {
      dateText: date,
      tab: 'top_couriers',
      kpis: {
        totalOrders: { label: 'Общее кол-во заказов', value: '54 шт', raw: 54 },
        totalRevenue: {
          label: 'Общая сумма заказов',
          value: '1,450 млн. сум',
          raw: 1450000000,
        },
        newClients: { label: 'Новые клиенты', value: '22 шт', raw: 22 },
        newCouriers: { label: 'Новые курьеры', value: '12 шт', raw: 12 },
        averageCheck: { label: 'Средний чек', value: '26 800 сум', raw: 26800 },
        averageDistance: {
          label: 'Ср. расстояние',
          value: '5 км/ 240 км',
          avgKm: 5,
          maxKm: 240,
        },
      },
      sales: {
        title: 'Заказы топ курьеров',
        total: '54 шт',
        periodLabel,
        points: [
          { date: '2026-10-24', label: 'Окт 24', value: 22000 },
          { date: '2026-10-25', label: 'Окт 25', value: 29000 },
          { date: '2026-10-26', label: 'Окт 26', value: 26000 },
          { date: '2026-10-27', label: 'Окт 27', value: 38000 },
          { date: '2026-10-28', label: 'Окт 28', value: 34000 },
          { date: '2026-10-29', label: 'Окт 29', value: 39000 },
          { date: '2026-10-30', label: 'Окт 30', value: 41000 },
          { date: '2026-10-31', label: 'Окт 31', value: 45000 },
        ],
        yTicks: [50000, 40000, 30000, 20000, 10000],
      },
      courierTracking: {
        title: 'Отслеживание топ курьеров',
        totalCouriers: 80,
        segments: [
          {
            id: 'with_order',
            label: 'С заказом',
            percentage: 65,
            count: 52,
            color: '#2EAD5F',
          },
          {
            id: 'two_orders',
            label: 'Два заказа',
            percentage: 25,
            count: 20,
            color: '#3B82F6',
          },
          {
            id: 'no_order',
            label: 'Без заказа',
            percentage: 7,
            count: 6,
            color: '#F59E0B',
          },
          { id: 'resting', label: 'Отдыхают', percentage: 3, count: 2, color: '#8B0A8B' },
        ],
      },
    };
  }

  if (tab === 'top_vendors') {
    return {
      dateText: date,
      tab: 'top_vendors',
      kpis: {
        totalOrders: { label: 'Общее кол-во заказов', value: '72 шт', raw: 72 },
        totalRevenue: {
          label: 'Общая сумма заказов',
          value: '1,980 млн. сум',
          raw: 1980000000,
        },
        newClients: { label: 'Новые клиенты', value: '29 шт', raw: 29 },
        newCouriers: { label: 'Новые курьеры', value: '8 шт', raw: 8 },
        averageCheck: { label: 'Средний чек', value: '27 500 сум', raw: 27500 },
        averageDistance: {
          label: 'Ср. расстояние',
          value: '4 км/ 190 км',
          avgKm: 4,
          maxKm: 190,
        },
      },
      sales: {
        title: 'Все продажи вендеров',
        total: '72 шт',
        periodLabel,
        points: [
          { date: '2026-10-24', label: 'Окт 24', value: 30000 },
          { date: '2026-10-25', label: 'Окт 25', value: 35000 },
          { date: '2026-10-26', label: 'Окт 26', value: 32000 },
          { date: '2026-10-27', label: 'Окт 27', value: 44000 },
          { date: '2026-10-28', label: 'Окт 28', value: 37000 },
          { date: '2026-10-29', label: 'Окт 29', value: 42000 },
          { date: '2026-10-30', label: 'Окт 30', value: 46000 },
          { date: '2026-10-31', label: 'Окт 31', value: 49000 },
        ],
        yTicks: [50000, 40000, 30000, 20000, 10000],
      },
      courierTracking: {
        title: 'Отслеживание курьеров у вендеров',
        totalCouriers: 90,
        segments: [
          {
            id: 'with_order',
            label: 'С заказом',
            percentage: 60,
            count: 54,
            color: '#2EAD5F',
          },
          {
            id: 'two_orders',
            label: 'Два заказа',
            percentage: 24,
            count: 22,
            color: '#3B82F6',
          },
          {
            id: 'no_order',
            label: 'Без заказа',
            percentage: 11,
            count: 10,
            color: '#F59E0B',
          },
          { id: 'resting', label: 'Отдыхают', percentage: 5, count: 4, color: '#8B0A8B' },
        ],
      },
    };
  }

  // Default: 'eats' (exact Figma numbers)
  return {
    dateText: date,
    tab: 'eats',
    kpis: {
      totalOrders: { label: 'Общее кол-во заказов', value: '38 шт', raw: 38 },
      totalRevenue: {
        label: 'Общая сумма заказов',
        value: '1,020 млн. сум',
        raw: 1020000000,
      },
      newClients: { label: 'Новые клиенты', value: '15 шт', raw: 15 },
      newCouriers: { label: 'Новые курьеры', value: '5 шт', raw: 5 },
      averageCheck: { label: 'Средний чек', value: '24 500 сум', raw: 24500 },
      averageDistance: {
        label: 'Ср. расстояние',
        value: '4 км/ 210 км',
        avgKm: 4,
        maxKm: 210,
      },
    },
    sales: {
      title: 'Все продажи Eats',
      total: '38 шт',
      periodLabel,
      points: [
        { date: '2026-10-24', label: 'Окт 24', value: 32000 },
        { date: '2026-10-25', label: 'Окт 25', value: 36000 },
        { date: '2026-10-26', label: 'Окт 26', value: 31000 },
        { date: '2026-10-27', label: 'Окт 27', value: 46000 },
        { date: '2026-10-28', label: 'Окт 28', value: 24000 },
        { date: '2026-10-29', label: 'Окт 29', value: 38000 },
        { date: '2026-10-30', label: 'Окт 30', value: 32000 },
        { date: '2026-10-31', label: 'Окт 31', value: 43000 },
      ],
      yTicks: [50000, 40000, 30000, 20000, 10000],
    },
    courierTracking: {
      title: 'Отслеживание курьеров',
      totalCouriers: 100,
      segments: [
        {
          id: 'with_order',
          label: 'С заказом',
          percentage: 58,
          count: 58,
          color: '#2EAD5F',
        },
        {
          id: 'two_orders',
          label: 'Два заказа',
          percentage: 22,
          count: 22,
          color: '#3B82F6',
        },
        {
          id: 'no_order',
          label: 'Без заказа',
          percentage: 13,
          count: 13,
          color: '#F59E0B',
        },
        { id: 'resting', label: 'Отдыхают', percentage: 7, count: 7, color: '#8B0A8B' },
      ],
    },
  };
}
